module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-play-fill-815d1633.svg";